import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { EventsEmitterService } from '../../services/events-emitter.service'

@Component({
  selector: 'ld-messages',
  template: require('./messages.component.html'),
  styles: [require('./messages.component.css')]
})
export class MessagesComponent implements OnInit, OnDestroy {
  private message = {}
  private routerSub
  private allEmitSub

  constructor (private messagesDelegate: MessagesDelegate, private router: Router, private eventsEmitterService: EventsEmitterService) {
    this.message = {}

    this.messagesDelegate.subscribe((msg) => this.message = msg)

     // reset display when route change
    this.routerSub = this.router.events.subscribe((event) => {
      this.message = this.messagesDelegate.last()
    })

    // reset display when all events
    this.allEmitSub = this.eventsEmitterService.subscribe('all', () => {
      this.message = this.messagesDelegate.last()
    })
  }

  ngOnInit () {
    this.message = this.messagesDelegate.last()
  }

  ngOnDestroy () {
    this.routerSub.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/messages/messages.component.ts